<template>
  <div class="text-center smart-search-error-container">
    <div class="smart-search-error-image-container">
      <img src="../../assets/jyranians/jyranian-telescope.png" alt="figure with telescope" />
    </div>
    <h2 data-test="jyre-recommends-server-error">Sorry, an error occurred.</h2>
    <h3>Please refresh the page and try again.</h3>
    <div class="center-flex mt-20">
      <a class="btn btn-default-back" href="/home" data-test="trial-limit-exceeded-button">
        Back to Home
      </a>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

.smart-search-error-container {
  border-radius: 10px;
  padding-bottom: 2rem;
  margin-top: -60px;
  @media (max-width: @screen-xxs-max) {
    padding: 0;
    margin: -30px;
  }
}

.smart-search-error-image-container {
  img {
    width: 400px;
    margin-bottom: -20px;

    @media (max-width: @screen-xxs-max) {
      width: 80%;
    }
  }
}

.mt-20 {
  margin-top: 20px;
}
</style>
